import { warrantyLogContext } from '../model/warranty-log-context';
import { Header } from './header/header';
import { WarrantyLogsTable } from './list/warranty-logs-table';
import { ListViewProvider } from 'components/table/contexts/list-view';
import { QueryRequestProvider } from 'components/table/contexts/query-request';
import { QueryResponseProvider } from 'components/table/contexts/query-response';
import { QueryState } from 'components/table/types';
import { useWarrantyLogQuery, WarrantyLogFilter } from 'entities/warranty';
import { Card } from 'react-bootstrap';

export const PageWrapper = () => {
  const runQuery = (state: QueryState) => {
    const filter = (state.filter as WarrantyLogFilter) || {};

    return useWarrantyLogQuery({
      ...filter,
      sort: state.sort,
      order: state.order,
      page: state.page,
      maxCount: state.items_per_page
    });
  };
  return (
    <QueryRequestProvider>
      <QueryResponseProvider queryResponseContext={warrantyLogContext} runQuery={runQuery}>
        <ListViewProvider queryResponseContext={warrantyLogContext}>
          <Card>
            <Card.Header>
              <div className="pt-6 w-100">
                <Header />
              </div>
            </Card.Header>
            <Card.Body>
              <WarrantyLogsTable />
            </Card.Body>
          </Card>
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  );
};
